import { useState, useCallback } from 'react';
import useCopilotChatContext from './useCopilotChatContext';

/**
 * Custom hook for handling "Start new chat" functionality
 * Centralizes the logic for creating a new conversation and resetting chat state
 */
export const useNewChat = () => {
	const { resetChat, assistantAlias, setIsLoading } = useCopilotChatContext();
	const [isResetting, setIsResetting] = useState(false);

	const handleNewChat = useCallback(async () => {
		if (isResetting || !resetChat || !assistantAlias) {
			if (!resetChat || !assistantAlias) {
				console.error('resetChat or assistantAlias not available');
			}
			return;
		}

		try {
			// Show loading indicator immediately
			setIsLoading(true);
			setIsResetting(true);
			console.log('[useNewChat] Starting new chat sequence');

			// Reset chat - this will call the backend /v1/copilot/chat/new endpoint
			// which creates a new conversation and returns the welcome message
			await resetChat();

			console.log('[useNewChat] New chat sequence complete');
		} catch (error) {
			console.error('[useNewChat] Failed to create new conversation:', error);
		} finally {
			setIsResetting(false);
		}
	}, [isResetting, resetChat, assistantAlias, setIsLoading]);

	return {
		handleNewChat,
		isResetting,
		canStartNewChat: !!resetChat && !!assistantAlias,
	};
};
